/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GithubLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,224a8.00039,8.00039,0,0,1-8,8,32.03667,32.03667,0,0,1-32-32v-8a16.01833,16.01833,0,0,0-16-16H156v40a16.01833,16.01833,0,0,0,16,16,8,8,0,0,1,0,16,32.03667,32.03667,0,0,1-32-32V176H116v40a32.03667,32.03667,0,0,1-32,32,8,8,0,0,1,0-16,16.01833,16.01833,0,0,0,16-16V176H88a16.01833,16.01833,0,0,0-16,16v8a32.03667,32.03667,0,0,1-32,32,8,8,0,0,1,0-16,16.01833,16.01833,0,0,0,16-16v-8a31.9949,31.9949,0,0,1,14.78076-26.95068A55.951,55.951,0,0,1,48,120v-8a58.0419,58.0419,0,0,1,7.69482-28.32031A59.73551,59.73551,0,0,1,61.07178,36,7.99908,7.99908,0,0,1,68,32a59.74952,59.74952,0,0,1,48.00732,23.999L139.99219,56A59.74792,59.74792,0,0,1,188,32a7.99908,7.99908,0,0,1,6.92822,4,59.73339,59.73339,0,0,1,5.37647,47.67969A58.04124,58.04124,0,0,1,208,112v8a55.951,55.951,0,0,1-22.78076,45.04932A31.9949,31.9949,0,0,1,200,192v8a16.01833,16.01833,0,0,0,16,16A8.00039,8.00039,0,0,1,224,224Z" />
    </Svg>
  );
}

export default GithubLogo;
